import { createContext, useContext } from 'react';
import type { FlushStop } from './outbox-flush';
import type { OutboxItem } from './outbox.types';

export type OfflineSyncValue = {
  isOnline: boolean;
  /** Waiting to be sent (status pending) for the signed-in account. */
  pendingCount: number;
  /** Refused for good, kept for the person to retry or delete. */
  failedItems: OutboxItem[];
  isSyncing: boolean;
  /** Why the last flush stopped before the end, if it did. */
  lastStop: FlushStop | null;
  syncNow: () => void;
  retryItem: (id: string) => Promise<void>;
  deleteItem: (id: string) => Promise<void>;
};

const idle: OfflineSyncValue = {
  isOnline: true,
  pendingCount: 0,
  failedItems: [],
  isSyncing: false,
  lastStop: null,
  syncNow: () => undefined,
  retryItem: async () => undefined,
  deleteItem: async () => undefined,
};

export const OfflineSyncContext = createContext<OfflineSyncValue>(idle);

/** Offline state and outbox of the signed-in account (inert outside OfflineSyncProvider). */
export const useOfflineSync = () => useContext(OfflineSyncContext);
